
const APIurl = "https://koparkoladowarka-99ee7a3b3d34.herokuapp.com";

const apiFetcher = {

  
  async getProvinces(province) {
    try {
      const response = await fetch(`${APIurl}/api/get-province?province=${province}`);
      if (!response.ok) throw new Error("Error fetching provinces");
      return response.json();
    }catch(error) {
      throw error
    }

  },

  async getDistricts(province) {
    try {
      const response = await fetch(`${APIurl}/api/get-district?province=${province}`);
      if (!response.ok) throw new Error("Error fetching districts");
      return response.json();
    }catch(error) {
      throw error
    }

  },

  async getCommunes(district) {
    try {
      const response = await fetch(`${APIurl}/api/get-commune?district=${district}`);
      if (!response.ok) throw new Error("Error fetching communes");
      return response.json();
    }catch(error) {
      throw error
    }

  },

  async getCities(commune) {
    try {
      const response = await fetch(`${APIurl}/api/get-city?commune=${commune}`);
      if (!response.ok) throw new Error("Error fetching cities");
      return response.json();
    }catch(error) {
      throw error
    }

  },

  async getServices(city) {
    try {
      const response = await fetch(`${APIurl}/api/get-service?city=${city}`);
      if (!response.ok) throw new Error("Error fetching services");
      return response.json();
    }catch(error) {
      throw error
    }

  },


  async getPrice(city, service) {
    try {
      const response = await fetch(`${APIurl}/api/get-price?city=${city}&service=${service}`);
      if (!response.ok) throw new Error("Error fetching price");
      return response.json();
    }catch(error) {
      throw error
    }

  },

  async addEventToGoogleCalendar(event) {
    try {
      const response = await fetch(`${APIurl}/api/add-event`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(event),
      });
      return response.json();
    }catch(error) {
      throw error
    }

  },


  async deleteCode(code) {
    try {
      const token = localStorage.getItem(`jwt`);
      const response = await fetch(`${APIurl}/api/delete-code?code=${code}`, {
        method: "DELETE",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` },
      });
      return response.json();
    } catch (error) {
      throw error
    }
  },

  async getPoints(userId, token) {
    try {
      const response = await fetch(`${APIurl}/api/get-points?userId=${userId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.json();
    } catch (error) {
      throw error
    }
  },

  async authenticateToken(token) {
    try {
      const response = await fetch(`${APIurl}/api/auth-token`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.json();
    } catch (error) {
      throw error
    }
  },

  async addAwaitingPoints(userId, points) {
    try {
      const response = await fetch(`${APIurl}/api/add-awaiting-points?userId=${userId}&points=${points}`, {
        method: "GET",
      });

      return await response.json();
    } catch (error) {
      throw error
    }
  },

  async sendUserData(method, userData) {
    try {
      const response = await fetch(`${APIurl}/api/${method}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });
      const data = await response.json();

      if (data.response.token) localStorage.setItem("jwt", data.response.token);
      if (!response.ok) return;
      return data.response || false;
    } catch (error) {
      throw error
    }
  },

 async createOrder(order) {
    console.log(order)
    try {
      const response = await fetch(`${APIurl}/api/orders`,{
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(order)
      })

      return response;

    }catch(error) {
      throw error
    }
  },

  async getDiscountByCode(code) {
    try {
      const response = await fetch(`${APIurl}/api/get-discount-by-code?code=${code}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      })

      const data = await response.json();

      if(data.message) {
        return false;
      }
      const {discountData} = data;
      return discountData;
    }catch(error) {
      throw error
    }
  },

  async buyDiscount(discountData) {
    try {
        const token = localStorage.getItem(`jwt`);
        if(!token) return;
        if(!discountData) return;
        const response = await fetch(`${APIurl}/api/buy-discount`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
           },
           body: JSON.stringify(discountData)
        })
        if(!response) return false;
        const {success} = await response.json();
        return success;


    }catch(error) {
      throw error
    }
  },


  async getDiscounts() {
    try {
        const token = localStorage.getItem(`jwt`);
        if(!token) return;
        const response = await fetch(`${APIurl}/api/get-discounts`, {
          method: "GET",
          headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
           },
        })
        if(!response) return false;

        const {confirmed, discounts} = await response.json();
        if(!confirmed) return false;
        return discounts;
    }catch(error) {
      throw error
    }
  },

  async AddPointsByRefCode(code,token) {
    try {
      const data = {
        code: code,
        userId: token?.id || null
      }

      const response = await fetch(`${APIurl}/api/add-points-by-ref`, {
        method: `POST`,
        headers: {"Content-Type": "application/json",
        },
        body: JSON.stringify(data)
      })

      return await response.json();
    }catch(error) {

    }
  },

  async createPayOutLink(amount) {
    try {
      const token = localStorage.getItem(`jwt`);
      if(!token) return false;
      const response = await fetch(`${APIurl}/api/create-payout-link?amount=${amount}`, {
        method: `Get`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        }
      });

      if(!response) return false;
      
      return await response.json();

    }catch(error) {
      throw error
    }
  }
};



export default apiFetcher;